// instantSearch.js: https://community.algolia.com/instantsearch.js/v2/getting-started.html

(function (window, document, $) {

    const init = () => {
        const searchIndex = location.host === 'raygun.com' ? 'prod' : 'dev';

        const search = window.instantsearch({
            appId: 'ZYP4EB8MXU',
            apiKey: '28fd354c7f40ad6a945b6e37e29fa72e',
            indexName: `${searchIndex}_BLOG`,
            routing: true
        });

        let timerId;

        // Search input
        search.addWidget(
            instantsearch.widgets.searchBox({
                container: '#searchbox',
                magnifier: false,
                reset: false,
                autofocus: true,
                queryHook(query, search) {
                    clearTimeout(timerId);
                    timerId = setTimeout(() => search(query), 250);
                },
            })
        );

        // Results
        search.addWidget(
            window.instantsearch.widgets.hits({
                container: '#hits',
                cssClasses: {
                    root: 'push',
                    empty: 'search-results__result',
                    item: 'posts post list-post',
                },
                transformItems: (items) => {
                    items.map((item, i) => {
                        const dirs = item.dir.split('\\');
                        dirs.pop();
                        const dirsMap = dirs.map((d, i) => ({
                            dir: d,
                            url: `/blog/${dirs.slice(0, i + 1).join('/')}`
                        }));

                        item.relPermalink = item.permalink.replace(/https?:\/\/raygun.com/, '');
                        item.dirs = dirsMap;
                        items[i] = item;

                        if (!item.featured_image) {
                            items[i].featured_image = 'images/placeholder.png';
                        }

                        if (item.categories) {
                            var htmlString = '';
                            item.categories.map(function(c) {
                                htmlString += `<li><a href="/blog/categories/${c.toLowerCase().replace(' ', '-')}/">${c}</a></li>`
                            });
                            items[i].htmlCategories = htmlString;
                        }

                        if (item.title === 'Search') {
                            items.splice(i, 1)
                        }
                    });

                    return items;
                },
                templates: {
                    empty: `
                        <h2>No results</h2>
                    `,
                    item: `
                        <article>
                            <div class="inner">
                                <div class="post-thumbnail">
                                    <figure class="post-image">
                                    <a class="post-image-link" href="{{relPermalink}}">
                                        <img src="../{{featured_image}}" alt="{{featured_image_alt_text}}">
                                    </a>
                                    </figure>
                                </div>
                                <div class="post-metadata post-metadata--search">
                                    <ul class="post-categories">
                                        {{{htmlCategories}}}
                                    </ul>
                                    <h2 class="post-title"><a href="{{relPermalink}}">{{title}}</a></h2>
                                </div>
                            </div>
                        </article>
                    `,
                },
            })
        );
        search.start();
    };

    $(document).ready(init);
})(window, window.document, window.jQuery);